<template>
    <div class="main-contianer">
        <h1>Your invoices</h1>
        <v-data-table
            class="data-table"
            :headers="headers"
            :items="invoices"
        >
            <template v-slot:item.created="{ item }">
                <p>{{ new Date(item.created * 1000).toLocaleDateString() }}</p>
            </template>
            <template v-slot:item.amount_due="{ item }">
                <p>${{ (item.amount_due / 100).toFixed(2) }}</p>
            </template>
            <template v-slot:item.amount_paid="{ item }">
                <p>${{ (item.amount_paid / 100).toFixed(2) }}</p>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip small :color="item.status === 'paid' ? 'success' : 'warning'">{{ item.status.charAt(0).toUpperCase() + item.status.slice(1) }}</v-chip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    name: 'InvoiceListComponent',
    props: {
        invoices: Array
    },
    data: () => {
        return {
            headers: [
                {
                    text: 'Created',
                    value: 'created'
                },
                {
                    text: 'Amount due',
                    value: 'amount_due'
                },
                {
                    text: 'Amount paid',
                    value: 'amount_paid'
                },
                {
                    text: 'Status',
                    value: 'status'
                },
            ]
        }
    }
};
</script>

<style lang="scss">
    h1 {
        font-size: 3rem;
        color: #18125a;
        text-align: center;
        margin-top: 40px;
        margin-bottom: 20px;
    }

    .v-data-table {
        width: 80%;
        margin: auto;

        .v-data-footer__select {
            font-size: 1.1rem;
        }
        .v-data-footer__pagination {
            font-size: 1.1rem;
        }

        th {
            font-size: 1.4rem !important;
        }

        td {
            font-size: 1.2rem !important;
        }
    }

    p {
        // font-size: 1.2rem;
        margin: 0 !important;
    }
</style>